export default __webpack_public_path__ + "static/media/Astro_Trine_Black.165ea1d6.png";